import styled from 'styled-components';

export const ThankYouWrapper = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  row-gap: 2rem;
`;

export const TankYouTextContainer = styled.div`
  display: grid;
  row-gap: 1rem;

  p {
    padding: 0;
  }

  .thank-you-masterclass-link {
    width: 100%;
    margin: 0.5rem 0;
    font-weight: 700;
  }
`;
